<div class="stepper col-12">
  <div class="row stepper-text">
    <span>{{ getActiveStepperText() }}</span>
  </div>
  <div class="row">
    <div [ngClass]="getStepperClass()" *ngFor="let step of stepperList">
      <span class="step-item" [ngClass]="{ active: step.isActive }"></span>
    </div>
  </div>
  <div class="stepper-body">
    <ng-container *ngTemplateOutlet="getActiveTemplateName()"> </ng-container>
    <div class="navigation-buttons">
      <button
        class="btn btn-primary"
        *ngIf="showBackButton()"
        (click)="backPage()"
      >
        Back
      </button>
      <button
        class="btn btn-primary"
        [disabled]="getStepperDisableNextButton()"
        *ngIf="showNextButton()"
        (click)="nextPage()"
      >
        Next
      </button>
      <button
        class="btn btn-primary"
        *ngIf="showFinishButton()"
        (click)="finishStep()"
      >
        Finished
      </button>
    </div>
  </div>
</div>
